// @flow
import _ from 'lodash'
import React, { Component, Fragment } from 'react'
import { translations, translateFunc } from '../../shared/localize'
import Modal from 'react-responsive-modal'
import dropdownWidget from '../../main/legacy/dropdownWidget'
import styled from 'styled-components'
import postJson from '../../services/postJson'

const Header = styled.div`
  font-size: 24px;
  font-weight: bold;
  padding-bottom: 10px;
`

const t = translateFunc(translations.replenishment)

type Response = {|
  errors?: Array<string>,
  notice?: string,
  redirect_to?: string
|}

type Props = {|
  value: string,
  replenishmentCommission: number,
  accountId: number,
  currency: string,
  url: string,
  onChange?: (string) => void
|}

type State = {|
  isLoading: boolean,
  notice: ?string,
  errors: ?Array<string>
|}

export default class Form extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { isLoading: false, notice: null, errors: null }
  }

  render() {
    let props = this.props
    let state = this.state
    const { isLoading, notice, errors } = this.state

    return (
      <div>
        <Modal
          open={!!(isLoading || notice || errors)}
          onClose={() => this.closeModal()}
          closeOnEsc={false}
          closeOnOverlayClick={false}
          showCloseIcon={!isLoading}
        >
          {state.isLoading && <h1>{t('processing')}</h1>}
          {state.errors && (
            <Fragment>
              <Header>{t('errors')}</Header>
              <div className="payment-form__message payment-form__message_error">{errors}</div>
            </Fragment>
          )}
          {state.notice && (
            <Fragment>
              <Header>{t('success')}</Header>
              <div className="payment-form__message payment-form__message_notice">{notice}</div>
            </Fragment>
          )}
        </Modal>
        <div>
          <input
            className="payment-form__add-money"
            value={props.value}
            onChange={(e) => this.inputChanged(e)}
          />
          <button className="payment-form__add-money-link" onClick={() => this.submit()}>
            {t('replenish')}
          </button>
        </div>
        <div className="balance-b__hint balance-b__hint_sum-with-commission">
          {this.realSumText()}
        </div>
      </div>
    )
  }

  closeModal() {
    this.setState({ notice: null, errors: null })
  }

  inputChanged(e: any) {
    this.props.onChange && this.props.onChange(e.target.value)
  }

  realSumText() {
    if (this.props.replenishmentCommission === 0) return t('no_commission')

    return t('amount_with_commission') + ' ' + this.sumWithCommission() + ' ' + this.props.currency
  }

  sum() {
    return parseFloat(this.props.value) || 0
  }

  sumWithCommission() {
    return Math.ceil(this.sum() / (1 - this.props.replenishmentCommission))
  }

  submit() {
    this.setState({ errors: null, notice: null, isLoading: true })

    postJson(this.props.url, {
      transaction: { amount: this.sum(), ad_account_id: this.props.accountId }
    })
      .done((response) => this.processResponse(response))
      .fail(() => window.alert('Internal server error'))
      .always(() => this.setState({ isLoading: false }))
  }

  processResponse(response: Response) {
    this.setState({ errors: response.errors, notice: response.notice })
    if (_.isEmpty(response.errors)) {
      dropdownWidget.hideAllWidgets()
    }
    if (response.notice) this.props.onChange && this.props.onChange('')

    if (response.redirect_to) window.location.href = response.redirect_to
  }
}
